import PropTypes from 'prop-types';
import React, { Component, createRef } from 'react';

export default class Networks extends Component {
    constructor(props) {
        super(props);

        this.state = {
            initiallySelectedId: JSON.stringify(props.selectedIds),
            selectedIds: props.selectedIds
        };

        this.wrapper = createRef();
        this.onChangeChecked = this.onChangeChecked.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        const initiallySelectedId = JSON.stringify(props.selectedIds);
        return initiallySelectedId !== state.initiallySelectedId
            ? {
                  initiallySelectedId: initiallySelectedId,
                  selectedIds: props.selectedIds
              }
            : null;
    }

    componentDidMount() {
        wo$(this.wrapper.current).find('[data-toggle="popover"]').popover();
    }

    onChangeChecked(event) {
        const id = Number.parseInt(event.target.id);
        const selectedIds = (this.state.selectedIds || []).slice();
        const currentChecked = !selectedIds || selectedIds.some(p => id === p);

        const checked = !currentChecked;
        if (checked) {
            selectedIds.push(id);
        }

        this.setState({ selectedIds: selectedIds }, () => {
            if (this.props.onChangeItemChecked) {
                this.props.onChangeItemChecked(id, checked);
            }
        });
    }

    render() {
        const resources = this.props.resources;
        return (
            <div className="row bor-b-1 pad-t-2 mar-b-3" ref={this.wrapper}>
                <div
                    className="col-xs-24 col-sm-24 col-md-6 hover-bg"
                    data-content={resources.networkDescription}
                    data-container="body"
                    data-toggle="popover"
                    data-placement="top"
                    data-original-title=""
                    title=""
                >
                    <h5 className="font-5 mar-0 mar-b-3-xs mar-b-3-sm">
                        {`${resources.network} `}
                        <span className="text-muted font-6">
                            <i className="fa fa-info-circle"></i>
                        </span>
                    </h5>
                </div>
                <div className="col-xs-24 col-sm-24 col-md-18">
                    <ul className="mar-0 supplier-list block-grid-xs-2 block-grid-md-3">
                        {this.props.items
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .map(item => {
                                const checked =
                                    !this.state.selectedIds || this.state.selectedIds.some(id => id === item.id);

                                return (
                                    <li key={`state-${item.id}`}>
                                        <div className="checkbox-tick font-4">
                                            <input
                                                type="checkbox"
                                                id={item.id}
                                                checked={checked}
                                                onChange={this.onChangeChecked}
                                            />
                                            <label className="font-300 font-3-xs" htmlFor={item.id}>
                                                <span>{item.name}</span>
                                            </label>
                                        </div>
                                    </li>
                                );
                            })}
                    </ul>
                </div>
            </div>
        );
    }
}

/* eslint-disable import/no-named-as-default-member */
Networks.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string
        })
    ).isRequired,

    selectedIds: PropTypes.arrayOf(PropTypes.number)
};
/* eslint-enable */
